const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInlaocitizen',
    accessToken: 'accessTokenlaocitizen',
    userRole: 'userRole',
  }
}

export default AppConfig;
